export const SHIMMER_STYLE = `
  @keyframes shimmer {
    0%   { background-position: -600px 0; }
    100% { background-position:  600px 0; }
  }
  .sk {
    background: linear-gradient(
      90deg,
      var(--surface-elevated) 25%,
      var(--surface-default)  50%,
      var(--surface-elevated) 75%
    );
    background-size: 600px 100%;
    animation: shimmer 1.4s ease-in-out infinite;
    border-radius: var(--radius-md);
  }
`;

type BoneProps = {
	width?: number | string;
	height?: number | string;
	radius?: string;
	style?: React.CSSProperties;
};

export function Bone({ width, height, radius, style }: BoneProps) {
	return (
		<div
			className="sk"
			style={{
				width,
				height,
				borderRadius: radius,
				flexShrink: 0,
				...style,
			}}
		/>
	);
}
